/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */
import React from "react";
import {
  Box,
  Grid,
  Button,
  Stack,
  useTheme,
  alpha,
  Avatar,
} from "@mui/material";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import { withWidth } from "@material-ui/core";
import LockIcon from "@mui/icons-material/Lock";
import { IParlayOutcome, IShopOutcome } from "./store/types";

const BetRow = ({
  parlayOutcome,
  isUserPremium,
  type,
  onClick,
  contrastCardBackground = false,
  dataPoints,
}: {
  parlayOutcome: IParlayOutcome | IShopOutcome;
  isUserPremium: boolean;
  type: "Add" | "Remove" | "Swap";
  dataPoints: {
    header: string;
    data: string | number | React.ReactNode;
    highlight?: number;
  }[];
  onClick: (o: IParlayOutcome) => void;
  contrastCardBackground: boolean;
}) => {
  const theme = useTheme();

  const {
    eventLabel,
    leagueCode,
    line,
    label,
    offerName,
    participantName,
    participantLabel,
    playerParticipantHeadShot,
    outcomeId,
    playerTeamAbbreviation,
    injuryStatus,
  } = parlayOutcome;

  const endIcon = () => {
    if (!isUserPremium) {
      return <HttpsOutlinedIcon fontSize="small" />;
    }
    switch (type) {
      case "Remove": {
        return <RemoveCircleIcon>Remove</RemoveCircleIcon>;
      }
      case "Swap": {
        return <SwapHorizontalCircleIcon>Swap</SwapHorizontalCircleIcon>;
      }
      default: {
        return <AddCircleIcon>Add</AddCircleIcon>;
      }
    }
  };

  const colorDictionary = {
    Add: {
      border: `0.5px solid #00954D`,
      color: "#00954D",
      backgroundColor: alpha("#00954D", 0.1),
      "&:hover": {
        border: `0.5px solid #00954D`,
      },
    },
    Swap: {
      border: `0.5px solid #4395FF`,
      color: "#4395FF",
      backgroundColor: alpha("#4395FF", 0.1),
      "&:hover": {
        border: `0.5px solid #4395FF`,
      },
    },
    Remove: {
      border: `0.5px solid #EE707E`,
      color: "#EE707E",
      backgroundColor: alpha("#EE707E", 0.1),
      "&:hover": {
        border: `0.5px solid #EE707E`,
      },
    },
  };

  return (
    <Grid
      id="row-content-root"
      container
      item
      sx={{
        border: `1px solid ${'#101010'}`,
        borderRadius: "12px",
        boxShadow: theme.shadows[2],
        overflow: "hidden",
        width: "100%",
        backgroundColor: '#1C1C1C',
        "&:not(:last-child)": {
          marginBottom: 24,
        },
        ...(contrastCardBackground && {
          backgroundColor: '#1C1C1C',
        }),
      }}
    >
      <Grid id="top-row" container item xs={12} justifyContent="space-between">
        <Grid
          id="player-information"
          container
          item
          justifyContent={"flex-start"}
          alignItems={"center"}
          xs={9}
          sx={{
            flexWrap: "nowrap",
            alignItems: "center",
          }}
        >
          <Grid
            id="player-photo"
            item
            xs={2}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Avatar
                src={playerParticipantHeadShot}
                alt={participantName}
                sx={{
                  height: 30,
                  width: 30,
                  backgroundColor: alpha(theme.palette.common.white, 0.15),
                }}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              spacing={0.5}
              sx={{
                paddingTop: "8px",
                fontSize: { xs: "12px", md: "16px" },
                overflow: "hidden",
                display: "inherit",
                justifyContent: "center",
                alignItems: "flex-start",
                width: "100%",
                textWrap: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              <Stack direction={"row"} spacing={1}>
                <Box
                  sx={{
                    color: alpha(theme.palette.common.white, 0.87),
                    fontWeight: 500,
                  }}
                >
                  {participantLabel}
                </Box>
                <Box
                  sx={{
                    color: "#FF5353",
                    display: injuryStatus ? "inherit" : "hidden",
                  }}
                >
                  {injuryStatus}
                </Box>
              </Stack>
              <Box
                fontWeight={700}
                textOverflow="ellipsis"
                overflow="hidden"
                fontSize={{ xs: "12px", md: "16px" }}
                color={alpha(theme.palette.common.white, 0.87)}
              >
                {label} {line} {offerName}
              </Box>
              <Stack
                direction="row"
                spacing={0.5}
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "10px",
                  color: 'white'
                }}
              >
                <Box
                  sx={{
                    backgroundColor: alpha(theme.palette.common.white, 0.15),
                    padding: "2px 4px",
                    borderRadius: 4,
                  }}
                >
                  {leagueCode}
                </Box>
                <Box
                  sx={{
                    fontWeight: 800,
                  }}
                >
                  {playerTeamAbbreviation}
                </Box>
                <Box>{eventLabel}</Box>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={3}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Grid
            id="player-contest-action-button"
            item
            xs={12}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{
              paddingRight: "8px",
              paddingTop: "8px",
              "& .MuiButton-outlinedPrimary": {
                borderRadius: "6px",

                fontSize: "12px",
                width: "84px",
                height: "28px",
                "& svg": {
                  width: 16,
                  height: 16,
                },
                ...colorDictionary[type],
              },
            }}
          >
            <Button
              variant="outlined"
              endIcon={endIcon()}
              onClick={() => onClick(parlayOutcome as IParlayOutcome)}
            >
              {type}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        id="bottom-row"
        container
        item
        xs={12}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ padding: 0, color: 'white', }}
      >
        <Grid id="highlighted-data-points" container item xs={2}>
          {dataPoints
            ?.filter((value) => !!value.highlight)
            .map((x, index) => {
              return (
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  padding="6px 10px"
                  sx={{
                    backgroundColor: alpha("#009F52", x.highlight || 1),
                    borderTopRightRadius: "12px",
                  }}
                  key={outcomeId}
                >
                  <Box fontSize="8px" fontWeight={500}>
                    {x.header}
                  </Box>
                  <Box fontSize="14px" fontWeight={700}>
                    {isUserPremium ? (
                      x.data || "-"
                    ) : (
                      <LockIcon
                        fontSize="small"
                        sx={{ fontSize: "20px", pt: "4px" }}
                      />
                    )}
                  </Box>
                </Stack>
              );
            })}
        </Grid>
        <Grid
          id="right-side-group"
          container
          item
          xs={10}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Grid
            id="regular-data-points"
            container
            item
            xs={8}
            alignItems={"center"}
            justifyContent={"flex-end"}
            sx={{ padding: "0px", flexWrap: "nowrap" }}
          >
            {dataPoints
              ?.filter((value) => !value.highlight)
              .map((x) => {
                return (
                  <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    padding="6px 10px"
                    key={outcomeId}
                  >
                    <Box fontSize="8px" fontWeight={500} whiteSpace="nowrap">
                      {x.header}
                    </Box>
                    <Box fontSize="12px" fontWeight={700} whiteSpace="nowrap">
                      {isUserPremium ? (
                        x.data || "-"
                      ) : (
                        <LockIcon
                          fontSize="small"
                          sx={{ fontSize: "20px", pt: "4px" }}
                        />
                      )}
                    </Box>
                  </Stack>
                );
              })}
          </Grid>
          <Grid
            id="data-button"
            // container
            item
            xs={3.2}
            alignItems={"center"}
            justifyContent={"center"}
          >
            {/* This isn't being used for V1, keep it here for future use and for layout purposes */}
            {/* <Box
              sx={{
                "& .MuiButton-outlinedPrimary": {
                  borderRadius: "6px",
                  fontSize: "12px",
                  width: "84px",
                  height: "28px",
                  "& svg": {
                    width: 16,
                    height: 16,
                  },
                  fontWeight: 400,
                  border: "1px solid rgba(255, 107, 0, 0.7)",
                  color: "rgba(255, 107, 0, 0.7)",
                  backgroundColor: "rgba(255, 107, 0, 0.10)",
                  "&:hover": {
                    border: "1px solid rgba(255, 107, 0, 0.7)",
                  },
                },
              }}
            >
              <Button
                variant="outlined"
                // onClick={() => onClick(parlayOutcome)}
              >
                Data
                <Image
                  src="/assets/img/chart_FILL0_wght200_GRAD0_opsz24.svg"
                  alt="data"
                  width={28}
                  height={28}
                  style={{
                    filter:
                      "invert(49%) sepia(40%) saturate(4603%) hue-rotate(359deg) brightness(101%) contrast(108%)",
                  }}
                />
              </Button>
            </Box> */}
          </Grid>
        </Grid>
      </Grid>
      {/* BDK FUTURE in V2 Add Drop down row for more odds */}
    </Grid>
  );
};

export default withWidth()(BetRow);
